import React, { useState, useEffect } from "react";
import { FaArrowDownShortWide } from "react-icons/fa6";
import { HiMiniArrowsUpDown } from "react-icons/hi2";
import copy from "clipboard-copy";
import data from "../../Utils/table1.json";
import Papa from "papaparse";
import { AiFillCaretDown } from "react-icons/ai";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "../../Style/CrmDashBoardTable.css";
import OutsideClickHandler from "react-outside-click-handler";
import DataTable from "react-data-table-component";

function Purchase({ tableData = [] }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(4);
  const [value, setValue] = useState("");

  const [sortColumn, setSortColumn] = useState(""); // Track sorting column
  const [sortDirection, setSortDirection] = useState("asc"); // Track sorting direction

  useEffect(() => {
    if (tableData.length) {
      setItemsPerPage(4);
    }
  }, [tableData]);

  const handleSort = (column) => {
    setSortColumn(column);
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
  };

  const filteredData = tableData
    .filter((ele) =>
      value === ""
        ? true
        : Object.values(ele).some((val) =>
            val?.toString().toLowerCase().includes(value.toLowerCase()),
          ),
    )
    .sort((a, b) => {
      if (!sortColumn) return 0;
      const aValue = a?.[sortColumn] ?? "";
      const bValue = b?.[sortColumn] ?? "";
      return aValue > bValue
        ? sortDirection === "asc"
          ? 1
          : -1
        : aValue < bValue
          ? sortDirection === "asc"
            ? -1
            : 1
          : 0;
    });

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filteredData.slice(
    startIndex,
    startIndex + itemsPerPage,
  );

  const columns = [
    {
      name: "Subject",
      selector: (row) => row.subject,
      sortable: true,
      omit: !tableData.length,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      omit: !tableData.length,
      cell: (row) => (
        <span
          style={{
            color: "#fff",
            backgroundColor: "#28a745",
            padding: "5px 10px",
            fontSize: "75%",
            fontWeight: "700",
            borderRadius: "0.25rem",
          }}
        >
          {row.status}
        </span>
      ),
    },
    {
      name: "Due Date",
      selector: (row) => row.duedate,
      sortable: true,
      omit: !tableData.length,
    },
    {
      name: "Priority",
      selector: (row) => row.priority,
      sortable: true,
      omit: !tableData.length,
    },
    {
      name: "Assigned",
      selector: (row) => row.assigned,
      sortable: true,
      omit: !tableData.length,
    },
    {
      name: "Created",
      selector: (row) => row.createdBy,
      sortable: true,
      omit: !tableData.length,
    },
  ];

  const handleSearch = (e) => {
    // Set the search input value to the current input field value
    setValue(e.target.value);
  };

  const [copied, setCopied] = useState(false);

  const handleCopyClick = () => {
    const formattedData = JSON.stringify(tableData, null, 2);
    copy(formattedData);
    setCopied(true);

    // Reset the copied status after a brief period
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  const convertToJson = () => {
    const csv = Papa.unparse(tableData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `data.csv`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const convertToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `data.xlsx`);
  };

  const convertToPdf = () => {
    const doc = new jsPDF();

    // Convert JSON data to a string and position it on the PDF
    const jsonString = JSON.stringify(tableData, null, 2);
    doc.text(jsonString, 10, 10);

    // Save the PDF
    doc.save(`data.pdf`);
  };

  const handlePrint = () => {
    const table = document.createElement("table");
    table.style.borderCollapse = "collapse"; // Adding border-collapse

    const tableBody = document.createElement("tbody");
    const headerRow = tableBody.insertRow();

    table.appendChild(tableBody);

    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
        <html>
        <head>
            <title>Print Table</title>
        </head>
        <body>
            ${table.outerHTML}
        </body>
        </html>
    `);

    printWindow.document.close();
    printWindow.print();
  };
  const [visibile, setVisible] = useState(false);
  const handleDrop = () => {
    setVisible(!visibile);
  };
  const [Id, setId] = useState(true);
  const [Subject, setSubject] = useState(true);
  const [Status, setStatus] = useState(true);
  const [Duedate, setDuedate] = useState(true);
  const [Assigned, setAssigned] = useState(true);
  const [Priority, setPriority] = useState(true);
  const [Created, setCreated] = useState(true);

  const handleID = () => {
    setId(!Id);
    setVisible(true);
  };
  const handleSubject = () => {
    setSubject(!Subject);
    setVisible(true);
  };
  const handleStatus = () => {
    setStatus(!Status);
    setVisible(true);
  };
  const handlePriority = () => {
    setPriority(!Priority);
    setVisible(true);
  };
  const handleAssigned = () => {
    setAssigned(!Assigned);
    setVisible(true);
  };
  const handleCreated = () => {
    setCreated(!Created);
    setVisible(true);
  };
  const handleDuedate = () => {
    setDuedate(!Duedate);
    setVisible(true);
  };
  return (
    <>
      <div
        className="d-flex justify-content-between my-3z"
        style={{
          "padding-bottom": "1rem",
        }}
      >
        <div className="bg-secondary mx-2 rounded Action d-flex">
          <label
            htmlFor=""
            className="px-2 py-1 m-0 item"
            onClick={handleCopyClick}
          >
            {copied ? "Copied!" : "Copy"}
          </label>
          <label
            htmlFor=""
            className="px-2 py-1 m-0 item"
            onClick={convertToJson}
          >
            CSV
          </label>
          <label
            htmlFor=""
            className="px-2 py-1 m-0 item"
            onClick={convertToExcel}
          >
            Excel
          </label>
          <label
            htmlFor=""
            className="px-2 py-1 m-0 item"
            onClick={convertToPdf}
          >
            PDF
          </label>
          <label
            htmlFor=""
            className="px-2 py-1 m-0 item"
            onClick={handlePrint}
          >
            Print
          </label>
          <OutsideClickHandler
            onOutsideClick={() => {
              setVisible(false);
            }}
          >
            <div className="dropdown">
              <label
                htmlFor=""
                className="px-2 py-1 m-0 item btn  dropdown-toggle"
                onClick={handleDrop}
                data-toggle="dropdown"
                style={{
                  color: "#fff",
                }}
              >
                Column Visibility
              </label>

              {/* Custom dropdown for column visibility */}
              <div
                className={`dropdown-menu ${
                  visibile ? "show" : ""
                } dropdown-menu-right`}
              >
                {/* Add your dropdown content here */}
                <div
                  className="menuItem"
                  onClick={handleID}
                  style={{
                    width: "200px",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    marginLeft: "5px",
                    marginRight: "5px",
                    borderRadius: "1px",
                    backgroundColor: Id ? "#007bff" : "",
                    color: Id ? "white" : "",
                  }}
                >
                  ID
                </div>
                <div
                  className="menuItem"
                  onClick={handleSubject}
                  style={{
                    width: "200px",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    marginLeft: "5px",
                    marginRight: "5px",
                    borderRadius: "1px",
                    backgroundColor: Subject ? "#007bff" : "",
                    color: Subject ? "white" : "",
                  }}
                >
                  Subject
                </div>
                <div
                  className="menuItem"
                  onClick={handleStatus}
                  style={{
                    width: "200px",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    marginLeft: "5px",
                    marginRight: "5px",
                    borderRadius: "1px",
                    backgroundColor: Status ? "#007bff" : "",
                    color: Status ? "white" : "",
                  }}
                >
                  Status
                </div>
                <div
                  className="menuItem"
                  onClick={handleDuedate}
                  style={{
                    width: "200px",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    marginLeft: "5px",
                    marginRight: "5px",
                    borderRadius: "1px",
                    backgroundColor: Duedate ? "#007bff" : "",
                    color: Duedate ? "white" : "",
                  }}
                >
                  Due Date
                </div>
                <div
                  className="menuItem"
                  onClick={handlePriority}
                  style={{
                    width: "200px",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    marginLeft: "5px",
                    marginRight: "5px",
                    borderRadius: "1px",
                    backgroundColor: Priority ? "#007bff" : "",
                    color: Priority ? "white" : "",
                  }}
                >
                  Priority
                </div>
                <div
                  className="menuItem"
                  onClick={handleAssigned}
                  style={{
                    width: "200px",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    marginLeft: "5px",
                    marginRight: "5px",
                    borderRadius: "1px",
                    backgroundColor: Assigned ? "#007bff" : "",
                    color: Assigned ? "white" : "",
                  }}
                >
                  Assigned
                </div>
                <div
                  className="menuItem"
                  onClick={handleCreated}
                  style={{
                    width: "200px",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    marginLeft: "5px",
                    marginRight: "5px",
                    borderRadius: "1px",
                    backgroundColor: Created ? "#007bff" : "",
                    color: Created ? "white" : "",
                  }}
                >
                  Created
                </div>
                {/* Add more dropdown items as needed */}
              </div>
            </div>
          </OutsideClickHandler>
        </div>
        <div className="Next2">
          <label htmlFor="" className="p-0 mx-1 my-0">
            Search :
          </label>
          <input
            type="text"
            className="Next3"
            onChange={(e) => setValue(e.target.value)} // Add onChange event to handle search
            value={value}
            style={{
              "border-radius": "unset",
              border: "1px solid ",
              borderRadius: "0",
            }}
          />
        </div>
      </div>

      <div className="table-container">
        <DataTable
          columns={columns}
          data={paginatedData}
          pagination
          paginationServer
          paginationTotalRows={filteredData.length}
          onChangePage={setCurrentPage}
          onChangeRowsPerPage={(newPerPage) => {
            setItemsPerPage(newPerPage);
            setCurrentPage(1);
          }}
          sortServer
          onSort={(column, sortDirection) => handleSort(column.name)}
          highlightOnHover
          striped
        />
      </div>
    </>
  );
}

export default Purchase;
